import mockDb from './mock-db'

const buildVersion = '1.0.0.0'
const mockdbchart = {
  getConsumptionChartWithErrors: {
    data: null,
    meta: { version: buildVersion },
    messages: [],
    errors: ['Hour, Minute, and Second parameters describe an un-representable DateTime.']
  },
  getConsumptionChartData: {
    data: {
      exportLinks: [
        {
          label: 'Exportera som tabell',
          url: 'https://ellevioweb.azurewebsites.net/privat/mina-sidor/elanvandning/excel?deliverySiteId=735999102100085348&period=',
          target: null
        },
        {
          label: 'Exportera som CSV',
          url: 'https://ellevioweb.azurewebsites.net/privat/mina-sidor/elanvandning/csv?deliverySiteId=735999102100085348',
          target: null
        }
      ],
      showPreviousButton: true,
      showNextButton: false,
      comparePrevious: true,
      comparePreviousYear: true,
      lowestResolution: 'Hourly',
      responseStartPeriod: '2021-02-01',
      responseEndPeriod: '2022-02-14',
      responseResolution: 'Monthly',
      energyForPeriod: 27007.23333,
      reactiveEnergyForPeriod: 9005.2,
      consumptions: [
        {
          normal: 0,
          total: 0,
          high: 599.4,
          low: 599.2,
          reactive: 599.6,
          start: '2021-02-03',
          end: '2021-02-28',
          status: 'OK',
          canFilter: true,
          maxPower: {
            value: mockDb.randomNumber(0, 20),
            date: '2021-07-01T19:00:00.000Z',
            timeString: '19:00 - 20:00'
          },
          tooltipText: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur arcu erat, accumsan id imperdiet et, porttitor at sem.'
        },
        {
          normal: 0,
          total: 0,
          high: 743.2,
          low: 743.1,
          reactive: 743.3,
          start: '2021-03-01',
          end: '2021-03-31',
          status: 'OK',
          canFilter: true,
          maxPower: {
            value: mockDb.randomNumber(0, 20),
            date: '2021-07-01T19:00:00.000Z',
            timeString: '19:00 - 20:00'
          },
          tooltipText: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur arcu erat, accumsan id imperdiet et, porttitor at sem.'
        },
        {
          normal: 719,
          total: 719,
          high: 719.2,
          low: 719.1,
          reactive: 719.3,
          start: '2021-04-01',
          end: '2021-04-30',
          status: 'OK',
          canFilter: true,
          maxPower: {
            value: mockDb.randomNumber(0, 20),
            date: '2021-07-01T19:00:00.000Z',
            timeString: '19:00 - 20:00'
          }
        },
        {
          normal: 743,
          total: 743,
          high: 743.2,
          low: 743.1,
          reactive: 743.3,
          start: '2021-05-01',
          end: '2021-05-31',
          status: 'OK',
          canFilter: true,
          maxPower: {
            value: mockDb.randomNumber(0, 20),
            date: '2021-07-01T19:00:00.000Z',
            timeString: '19:00 - 20:00'
          }
        },
        {
          normal: 719,
          total: 719,
          high: 719.2,
          low: 719.1,
          reactive: 719.3,
          start: '2021-06-01',
          end: '2021-06-30',
          status: 'OK',
          canFilter: true,
          maxPower: {
            value: mockDb.randomNumber(0, 20),
            date: '2021-07-01T19:00:00.000Z',
            timeString: '19:00 - 20:00'
          }
        },
        {
          normal: 743.344,
          total: 743.344,
          high: 743.2,
          low: 743.1,
          reactive: 743.3,
          start: '2021-07-01',
          end: '2021-07-31',
          status: 'OK',
          canFilter: true,
          maxPower: {
            value: mockDb.randomNumber(0, 20),
            date: '2021-07-01T19:00:00.000Z',
            timeString: '19:00 - 20:00'
          }
        },
        {
          normal: 743,
          total: 743,
          high: 743.2,
          low: 743.1,
          reactive: 743.3,
          start: '2021-08-01',
          end: '2021-08-31',
          status: 'OK',
          canFilter: true,
          maxPower: {
            value: mockDb.randomNumber(0, 20),
            date: '2021-07-01T19:00:00.000Z',
            timeString: '19:00 - 20:00'
          }
        },
        {
          normal: 719,
          total: 719,
          high: 719.2,
          low: 719.1,
          reactive: 719.3,
          start: '2021-09-01',
          end: '2021-09-30',
          status: 'OK',
          canFilter: true,
          maxPower: {
            value: mockDb.randomNumber(0, 20),
            date: '2021-07-01T19:00:00.000Z',
            timeString: '19:00 - 20:00'
          }
        },
        {
          normal: 743,
          total: 743,
          high: 743.2,
          low: 743.1,
          reactive: 743.3,
          start: '2021-10-01',
          end: '2021-10-31',
          status: 'OK',
          canFilter: true,
          maxPower: {
            value: mockDb.randomNumber(0, 20),
            date: '2021-07-01T19:00:00.000Z',
            timeString: '19:00 - 20:00'
          }
        },
        {
          normal: 719,
          total: 719,
          high: 719.2,
          low: 719.1,
          reactive: 719.3,
          start: '2021-11-01',
          end: '2021-11-30',
          status: 'OK',
          canFilter: true,
          maxPower: {
            value: mockDb.randomNumber(0, 20),
            date: '2021-07-01T19:00:00.000Z',
            timeString: '19:00 - 20:00'
          }
        },
        {
          normal: 743,
          total: 743,
          high: 743.2,
          low: 743.1,
          reactive: 743.3,
          start: '2021-12-01',
          end: '2021-12-31',
          status: 'OK',
          canFilter: true,
          maxPower: {
            value: mockDb.randomNumber(0, 20),
            date: '2021-07-01T19:00:00.000Z',
            timeString: '19:00 - 20:00'
          }
        },
        {
          normal: 743,
          total: 743,
          high: 743.2,
          low: 743.1,
          reactive: 743.3,
          start: '2022-01-01',
          end: '2022-01-31',
          status: 'OK',
          canFilter: true,
          maxPower: {
            value: mockDb.randomNumber(0, 20),
            date: '2021-07-01T19:00:00.000Z',
            timeString: '19:00 - 20:00'
          }
        },
        {
          normal: 325,
          total: 325,
          high: 325.2,
          low: 325.1,
          reactive: 325.3,
          start: '2022-02-01',
          end: '2022-02-14',
          status: 'OK',
          canFilter: true,
          maxPower: {
            value: mockDb.randomNumber(0, 20),
            date: '2021-07-01T19:00:00.000Z',
            timeString: '19:00 - 20:00'
          }
        }
      ],
      summary: {
        isConsumptionSite: false,
        availablePeriodsxxx: [
          {
            periodStartDate: '1982-06-15',
            periodEndDate: '2022-01-28',
            resolution: 'Daily'
          }
        ],
        availablePeriods: [
          {
            periodStartDate: '1982-06-15',
            periodEndDate: '1984-02-21',
            resolution: 'Monthly'
          },
          {
            periodStartDate: '1990-01-01',
            periodEndDate: '2012-08-12',
            resolution: 'Monthly'
          },
          {
            periodStartDate: '2012-08-13',
            periodEndDate: '2013-01-01',
            resolution: 'Hourly'
          },
          {
            periodStartDate: '2021-02-03',
            periodEndDate: '2021-02-04',
            resolution: 'Hourly'
          },
          {
            periodStartDate: '2021-02-05',
            periodEndDate: '2022-02-14',
            resolution: 'Hourly'
          }
        ],
        estimatedYearlyTotalEnergy: 17976,
        estimatedYearlyNormalEnergy: 5913,
        estimatedYearlyHighEnergy: 6781,
        estimatedYearlyLowEnergy: 5282,
        estimatedYearlyReactiveEnergy: 5529,
        actualEnergy: 4022,
        actualReactiveEnergy: 3249,
        maxPower: {
          value: 333,
          date: '2021-12-14T'
        },
        maxReactivePower: {
          value: 277,
          date: '2021-10-14'
        }
      }
    },
    meta: { version: buildVersion },
    messages: [],
    errors: []
  },
  getConsumptionChartDataTariff: {
    data: {
      responseStartPeriod: '2022-09-01T00:00:00',
      responseEndPeriod: '2022-09-30T23:59:59',
      responseStartWeek: 35,
      responseEndWeek: 39,
      responseResolution: 'Daily',
      showPreviousButton: true,
      lowestResolution: 'Hourly',
      showNextButton: true,
      comparePrevious: true,
      comparePreviousYear: true,
      energyForPeriod: 653.808,
      reactiveEnergyForPeriod: 0,
      consumptions: [
        {
          normal: 24.89,
          total: 24.89,
          high: 0,
          low: 0,
          reactive: 0,
          maxPower: {
            value: 2.03,
            date: '2022-09-01T17:00:00+01:00',
            timeString: '17:00 - 18:00',
            status: 'Missing'
          },
          start: '2022-09-01T00:00:00+01:00',
          end: '2022-09-01T23:59:59+01:00',
          dayLightSavingsTime: true,
          status: 'OK',
          canFilter: true
        },
        {
          normal: 28.899,
          total: 28.899,
          high: 0,
          low: 0,
          reactive: 0,
          maxPower: {
            value: 2.586,
            date: '2022-09-02T16:00:00+01:00',
            timeString: '16:00 - 17:00',
            status: 'Missing'
          },
          start: '2022-09-02T00:00:00+01:00',
          end: '2022-09-02T23:59:59+01:00',
          dayLightSavingsTime: true,
          status: 'OK',
          canFilter: true
        },
        {
          normal: 22.773,
          total: 22.773,
          high: 0.0,
          low: 0.0,
          reactive: 0.0,
          maxPower: { value: 12.519, date: '2022-09-03T01:00:00+01:00', timeString: '01:00 - 02:00', status: 'Ok' },
          start: '2022-09-03T00:00:00+01:00',
          end: '2022-09-03T23:59:59+01:00',
          dayLightSavingsTime: true,
          status: 'OK',
          canFilter: true
        },
        {
          normal: 24.209,
          total: 24.209,
          high: 0.0,
          low: 0.0,
          reactive: 0.0,
          maxPower: { value: 12.669, date: '2022-09-04T18:00:00+01:00', timeString: '18:00 - 19:00', status: 'Ok' },
          start: '2022-09-04T00:00:00+01:00',
          end: '2022-09-04T23:59:59+01:00',
          dayLightSavingsTime: true,
          status: 'OK',
          canFilter: true
        },
        {
          normal: 28.69,
          total: 28.69,
          high: 0.0,
          low: 0.0,
          reactive: 0.0,
          maxPower: { value: 12.052, date: '2022-09-05T06:00:00+01:00', timeString: '06:00 - 07:00', status: 'Missing' },
          start: '2022-09-05T00:00:00+01:00',
          end: '2022-09-05T23:59:59+01:00',
          dayLightSavingsTime: true,
          status: 'OK',
          canFilter: true
        },
        {
          normal: 23.692,
          total: 23.692,
          high: 0.0,
          low: 0.0,
          reactive: 0.0,
          maxPower: { value: 12.285, date: '2022-09-06T05:00:00+01:00', timeString: '05:00 - 06:00', status: 'Missing' },
          start: '2022-09-06T00:00:00+01:00',
          end: '2022-09-06T23:59:59+01:00',
          dayLightSavingsTime: true,
          status: 'OK',
          canFilter: true
        },
        {
          normal: 25.57,
          total: 25.57,
          high: 0.0,
          low: 0.0,
          reactive: 0.0,
          maxPower: { value: 15.17, date: '2022-09-07T17:00:00+01:00', timeString: '17:00 - 18:00', status: 'Missing' },
          start: '2022-09-07T00:00:00+01:00',
          end: '2022-09-07T23:59:59+01:00',
          dayLightSavingsTime: true,
          status: 'OK',
          canFilter: true
        },
        {
          normal: 28.169,
          total: 28.169,
          high: 0.0,
          low: 0.0,
          reactive: 0.0,
          maxPower: { value: 14.248, date: '2022-09-08T05:00:00+01:00', timeString: '05:00 - 06:00', status: 'Missing' },
          start: '2022-09-08T00:00:00+01:00',
          end: '2022-09-08T23:59:59+01:00',
          dayLightSavingsTime: true,
          status: 'OK',
          canFilter: true
        },
        {
          normal: 24.227,
          total: 24.227,
          high: 0.0,
          low: 0.0,
          reactive: 0.0,
          maxPower: { value: 11.881, date: '2022-09-09T19:00:00+01:00', timeString: '19:00 - 20:00', status: 'Missing' },
          start: '2022-09-09T00:00:00+01:00',
          end: '2022-09-09T23:59:59+01:00',
          dayLightSavingsTime: true,
          status: 'OK',
          canFilter: true
        },
        {
          normal: 32.665,
          total: 32.665,
          high: 0.0,
          low: 0.0,
          reactive: 0.0,
          maxPower: { value: 12.665, date: '2022-09-10T09:00:00+01:00', timeString: '09:00 - 10:00', status: 'Missing' },
          start: '2022-09-10T00:00:00+01:00',
          end: '2022-09-10T23:59:59+01:00',
          dayLightSavingsTime: true,
          status: 'OK',
          canFilter: true
        },
        {
          normal: 22.886,
          total: 22.886,
          high: 0.0,
          low: 0.0,
          reactive: 0.0,
          maxPower: { value: 11.942, date: '2022-09-11T20:00:00+01:00', timeString: '20:00 - 21:00', status: 'Missing' },
          start: '2022-09-11T00:00:00+01:00',
          end: '2022-09-11T23:59:59+01:00',
          dayLightSavingsTime: true,
          status: 'OK',
          canFilter: true
        },
        {
          normal: 24.437,
          total: 24.437,
          high: 0.0,
          low: 0.0,
          reactive: 0.0,
          maxPower: { value: 11.992, date: '2022-09-12T05:00:00+01:00', timeString: '05:00 - 06:00', status: 'Missing' },
          start: '2022-09-12T00:00:00+01:00',
          end: '2022-09-12T23:59:59+01:00',
          dayLightSavingsTime: true,
          status: 'OK',
          canFilter: true
        },
        {
          normal: 0.0,
          total: 0.0,
          high: 0.0,
          low: 0.0,
          reactive: 0.0,
          maxPower: { value: 0.0, date: '0001-01-01T00:00:00+00:00', timeString: null, status: 'Missing' },
          start: '2022-09-13T00:00:00+01:00',
          end: '2022-09-13T23:59:59+01:00',
          dayLightSavingsTime: true,
          status: 'OK',
          canFilter: true
        },
        {
          normal: 23.833,
          total: 23.833,
          high: 0.0,
          low: 0.0,
          reactive: 0.0,
          maxPower: { value: 12.276, date: '2022-09-14T17:00:00+01:00', timeString: '17:00 - 18:00', status: 'Missing' },
          start: '2022-09-14T00:00:00+01:00',
          end: '2022-09-14T23:59:59+01:00',
          dayLightSavingsTime: true,
          status: 'OK',
          canFilter: true
        },
        {
          normal: 29.882,
          total: 29.882,
          high: 0.0,
          low: 0.0,
          reactive: 0.0,
          maxPower: { value: 13.516, date: '2022-09-15T19:00:00+01:00', timeString: '19:00 - 20:00', status: 'Missing' },
          start: '2022-09-15T00:00:00+01:00',
          end: '2022-09-15T23:59:59+01:00',
          dayLightSavingsTime: true,
          status: 'OK',
          canFilter: true
        },
        {
          normal: 28.417,
          total: 28.417,
          high: 0.0,
          low: 0.0,
          reactive: 0.0,
          maxPower: { value: 13.404, date: '2022-09-16T19:00:00+01:00', timeString: '19:00 - 20:00', status: 'Missing' },
          start: '2022-09-16T00:00:00+01:00',
          end: '2022-09-16T23:59:59+01:00',
          dayLightSavingsTime: true,
          status: 'OK',
          canFilter: true
        },
        {
          normal: 34.008,
          total: 34.008,
          high: 0.0,
          low: 0.0,
          reactive: 0.0,
          maxPower: { value: 12.553, date: '2022-09-17T17:00:00+01:00', timeString: '17:00 - 18:00', status: 'Missing' },
          start: '2022-09-17T00:00:00+01:00',
          end: '2022-09-17T23:59:59+01:00',
          dayLightSavingsTime: true,
          status: 'OK',
          canFilter: true
        },
        {
          normal: 33.964,
          total: 33.964,
          high: 0.0,
          low: 0.0,
          reactive: 0.0,
          maxPower: { value: 12.637, date: '2022-09-18T17:00:00+01:00', timeString: '17:00 - 18:00', status: 'Missing' },
          start: '2022-09-18T00:00:00+01:00',
          end: '2022-09-18T23:59:59+01:00',
          dayLightSavingsTime: true,
          status: 'OK',
          canFilter: true
        },
        {
          normal: 30.637,
          total: 30.637,
          high: 0,
          low: 0,
          reactive: 0,
          maxPower: {
            value: 2.427,
            date: '2022-09-19T09:00:00+01:00',
            timeString: '09:00 - 10:00',
            status: 'Missing'
          },
          start: '2022-09-19T00:00:00+01:00',
          end: '2022-09-19T23:59:59+01:00',
          dayLightSavingsTime: true,
          status: 'OK',
          canFilter: true
        },
        {
          normal: 32.02,
          total: 32.02,
          high: 0,
          low: 0,
          reactive: 0,
          maxPower: {
            value: 2.15,
            date: '2022-09-20T07:00:00+01:00',
            timeString: '07:00 - 08:00',
            status: 'Missing'
          },
          start: '2022-09-20T00:00:00+01:00',
          end: '2022-09-20T23:59:59+01:00',
          dayLightSavingsTime: true,
          status: 'OK',
          canFilter: true
        },
        {
          normal: 30.076,
          total: 30.076,
          high: 0,
          low: 0,
          reactive: 0,
          maxPower: {
            value: 1.528,
            date: '2022-09-21T00:00:00+01:00',
            timeString: '00:00 - 01:00',
            status: 'Missing'
          },
          start: '2022-09-21T00:00:00+01:00',
          end: '2022-09-21T23:59:59+01:00',
          dayLightSavingsTime: true,
          status: 'OK',
          canFilter: true
        },
        {
          normal: 28.759,
          total: 28.759,
          high: 0,
          low: 0,
          reactive: 0,
          maxPower: {
            value: 1.666,
            date: '2022-09-22T07:00:00+01:00',
            timeString: '07:00 - 08:00',
            status: 'Missing'
          },
          start: '2022-09-22T00:00:00+01:00',
          end: '2022-09-22T23:59:59+01:00',
          dayLightSavingsTime: true,
          status: 'OK',
          canFilter: true
        },
        {
          normal: 27.813,
          total: 27.813,
          high: 0,
          low: 0,
          reactive: 0,
          maxPower: {
            value: 2.213,
            date: '2022-09-23T00:00:00+01:00',
            timeString: '00:00 - 01:00',
            status: 'Missing'
          },
          start: '2022-09-23T00:00:00+01:00',
          end: '2022-09-23T23:59:59+01:00',
          dayLightSavingsTime: true,
          status: 'OK',
          canFilter: true
        },
        {
          normal: 25.666,
          total: 25.666,
          high: 0,
          low: 0,
          reactive: 0,
          maxPower: {
            value: 1.86,
            date: '2022-09-24T21:00:00+01:00',
            timeString: '21:00 - 22:00',
            status: 'Missing'
          },
          start: '2022-09-24T00:00:00+01:00',
          end: '2022-09-24T23:59:59+01:00',
          dayLightSavingsTime: true,
          status: 'OK',
          canFilter: true
        },
        {
          normal: 0,
          total: 0,
          high: 0,
          low: 0,
          reactive: 0,
          maxPower: {
            value: 0,
            date: '0001-01-01T00:00:00+00:00',
            timeString: null,
            status: 'Missing'
          },
          start: '2022-09-25T00:00:00+01:00',
          end: '2022-09-25T23:59:59+01:00',
          dayLightSavingsTime: true,
          status: 'OK',
          canFilter: true
        },
        {
          normal: 0,
          total: 0,
          high: 0,
          low: 0,
          reactive: 0,
          maxPower: {
            value: 0,
            date: '0001-01-01T00:00:00+00:00',
            timeString: null,
            status: 'Missing'
          },
          start: '2022-09-26T00:00:00+02:00',
          end: '2022-09-26T23:59:59+02:00',
          dayLightSavingsTime: false,
          status: 'Missing',
          canFilter: true
        },
        {
          normal: 0,
          total: 0,
          high: 0,
          low: 0,
          reactive: 0,
          maxPower: {
            value: 0,
            date: '0001-01-01T00:00:00+00:00',
            timeString: null,
            status: 'Missing'
          },
          start: '2022-09-27T00:00:00+02:00',
          end: '2022-09-27T23:59:59+02:00',
          dayLightSavingsTime: false,
          status: 'Missing',
          canFilter: true
        },
        {
          normal: 0,
          total: 0,
          high: 0,
          low: 0,
          reactive: 0,
          maxPower: {
            value: 0,
            date: '0001-01-01T00:00:00+00:00',
            timeString: null,
            status: 'Missing'
          },
          start: '2022-09-28T00:00:00+02:00',
          end: '2022-09-28T23:59:59+02:00',
          dayLightSavingsTime: false,
          status: 'Missing',
          canFilter: true
        },
        {
          normal: 0,
          total: 0,
          high: 0,
          low: 0,
          reactive: 0,
          maxPower: {
            value: 0,
            date: '0001-01-01T00:00:00+00:00',
            timeString: null,
            status: 'Missing'
          },
          start: '2022-09-29T00:00:00+02:00',
          end: '2022-09-29T23:59:59+02:00',
          dayLightSavingsTime: false,
          status: 'Missing',
          canFilter: true
        },
        {
          normal: 0,
          total: 0,
          high: 0,
          low: 0,
          reactive: 0,
          maxPower: {
            value: 0,
            date: '0001-01-01T00:00:00+00:00',
            timeString: null,
            status: 'Missing'
          },
          start: '2022-09-30T00:00:00+02:00',
          end: '2022-09-30T23:59:59+02:00',
          dayLightSavingsTime: false,
          status: 'Missing',
          canFilter: true
        }
      ],
      summary: {
        isConsumptionSite: true,
        availablePeriods: [
          {
            periodStartDate: '2009-02-26T04:10:00',
            periodEndDate: '2011-09-05T00:00:00',
            resolution: 'Monthly'
          },
          {
            periodStartDate: '2009-02-26T04:10:00',
            periodEndDate: '2011-09-05T00:00:00',
            resolution: 'Monthly'
          },
          {
            periodStartDate: '2011-09-05T00:00:00',
            periodEndDate: '2013-05-28T02:00:00',
            resolution: 'Monthly'
          },
          {
            periodStartDate: '2011-09-05T00:00:00',
            periodEndDate: '2013-05-28T02:00:00',
            resolution: 'Monthly'
          },
          {
            periodStartDate: '2013-05-28T02:00:00',
            periodEndDate: '2080-01-01T00:00:00',
            resolution: 'Hourly'
          },
          {
            periodStartDate: '2013-05-28T02:00:00',
            periodEndDate: '2022-09-25T00:00:00',
            resolution: 'Hourly'
          }
        ],
        estimatedYearlyTotalEnergy: 14215,
        estimatedYearlyNormalEnergy: 0,
        estimatedYearlyHighEnergy: 14215,
        estimatedYearlyLowEnergy: 0,
        estimatedYearlyReactiveEnergy: 0,
        actualEnergy: 8958.55,
        actualReactiveEnergy: 0,
        maxPower: {
          value: 5.382,
          date: '2022-09-15T14:00:00+01:00'
        },
        maxReactivePower: null
      },
      exportLinks: [
        {
          label: 'Exportera som tabell',
          url: 'https://int.ellevio.se/privat/mina-sidor/elanvandning/excel?customerId=2802729&deliverySiteId=735999102105488564&from=2022-10-01+00:00:00&to=2022-10-31+00:00:00&resolution=daily&previous=true&next=false&interval=monthly',
          target: null
        },
        {
          label: 'Exportera som CSV',
          url: 'https://int.ellevio.se/privat/mina-sidor/elanvandning/csv?customerId=2802729&deliverySiteId=735999102105488564&from=2022-10-01+00:00:00&to=2022-10-31+00:00:00&resolution=daily&previous=true&next=false&interval=monthly',
          target: null
        }
      ],
      compareData: null
    },
    meta: {
      version: buildVersion
    },
    messages: [],
    errors: []
  }
}

//adjusted for interval - calculated using from and to.
const generatedObj = {
  interval: function (from, to, resolution) {
    const parsedTo = new Date(to)
    const parsedFrom = new Date(from)

    // if (resolution !== 'Hourly') {
    //   parsedTo.setUTCHours(0, 0, 0, 0)
    //   parsedFrom.setUTCHours(0, 0, 0, 0)
    // }

    let numOfLoops = 0

    const millisekOfYear = 1000 * 60 * 60 * 24 * 7 * 4 * 52
    const millisekOfMonth = 1000 * 60 * 60 * 24 * 7 * 4
    const millisekOfWeek = 1000 * 60 * 60 * 24 * 7
    const millisekOfDay = 1000 * 60 * 60 * 24
    const millisekOfHour = 1000 * 60 * 60

    const fromDateInMillisek = parsedFrom.getTime()
    const toDateInMillisek = parsedTo.getTime()

    const timeDiffInMillisek = toDateInMillisek - fromDateInMillisek === 0 ? millisekOfDay : toDateInMillisek - fromDateInMillisek

    const numberOfYears = timeDiffInMillisek / millisekOfYear
    const numberOfMonths = timeDiffInMillisek / millisekOfMonth
    const numberOfWeeks = timeDiffInMillisek / millisekOfWeek
    const numberOfDays = timeDiffInMillisek / millisekOfDay + 1
    const numberOfHours = timeDiffInMillisek / millisekOfHour

    if (resolution === 'Yearly') {
      numOfLoops = Math.round(numberOfYears)
    } else if (resolution === 'Monthly') {
      numOfLoops = Math.round(numberOfMonths)
    } else if (resolution === 'Weekly') {
      numOfLoops = Math.round(numberOfWeeks)
    } else if (resolution === 'Daily') {
      numOfLoops = Math.round(numberOfDays)
    } else if (resolution === 'Hourly') {
      numOfLoops = numberOfHours === 0 ? 24 : Math.round(numberOfHours)
    }

    const consumptionsArray = []

    for (let i = 0; i < numOfLoops; i++) {
      let periodStart = fromDateInMillisek + i * (timeDiffInMillisek / numOfLoops)
      let periodEnd = fromDateInMillisek + (i + 1) * (timeDiffInMillisek / numOfLoops)

      //Added decimals to testdata to better be able to test "real" data. If we want no decimals in testdata use Math.floor(Math.random() * 200) + 1450 in the end instead.
      const normal = parseInt(periodStart, 10) > new Date(new Date().setHours(0, 0, 0, 0)).getTime() ? 0 : Math.random() * 200 + 1450

      let maxPowerDate = new Date(new Date(parseInt(periodStart, 10)).toBackendDate())
      const randomStartHour = mockDb.randomNumber(0, 22)
      const maxPowerDateTimeString = `${randomStartHour.toString().padStart(2, '0')}:00 - ${(randomStartHour + 1).toString().padStart(2, '0')}:00`

      let simulateNoValue = false
      if (resolution !== 'Yearly' && i < 3) simulateNoValue = true

      consumptionsArray.push({
        normal: simulateNoValue ? 0 : resolution === 'Hourly' ? Math.random() * 6 : normal,
        total: simulateNoValue ? 0 : resolution === 'Hourly' ? Math.random() * 6 : normal,
        start: resolution !== 'Hourly' ? new Date(parseInt(periodStart, 10)).toBackendDate() : new Date(parseInt(periodStart, 10)),
        end: resolution !== 'Hourly' ? new Date(parseInt(periodEnd, 10)).toBackendDate() : new Date(parseInt(periodEnd, 10)),
        maxPower: {
          value: resolution === 'Hourly' || normal > 0 ? (resolution === 'Hourly' ? Math.random() * 6 : mockDb.randomNumber(0, 20) + 0.13) : 0,
          date: maxPowerDate,
          timeString: maxPowerDateTimeString
        },
        resolution: resolution,
        canFilter: resolution !== 'Hourly',
        tooltipText: simulateNoValue ? 'Quisque velit nisi, pretium ut lacinia in, elementum id enim. Quisque velit nisi, pretium ut lacinia in, elementum id enim.' : null
      })
    }

    let getConsumptionChartDataGenerated = {
      data: {
        exportLinks: [
          {
            label: 'Exportera som tabell',
            url: 'https://ellevioweb.azurewebsites.net/privat/mina-sidor/elanvandning/excel?deliverySiteId=735999102100085348&period=0&random=' + Math.floor(Math.random() * 100),
            target: null
          },
          {
            label: 'Exportera som CSV',
            url: 'https://ellevioweb.azurewebsites.net/privat/mina-sidor/elanvandning/csv?deliverySiteId=735999102100085348&random=' + Math.floor(Math.random() * 200),
            target: null
          }
        ],
        showPreviousButton: true,
        showNextButton: true,
        comparePrevious: true,
        comparePreviousYear: true,
        lowestResolution: 'Hourly',
        responseStartPeriod: new Date(fromDateInMillisek).toBackendDate(), //'2021-02-01',
        responseEndPeriod: new Date(toDateInMillisek).toBackendDate(), //'2022-02-14',
        responseResolution: 'Monthly',
        energyForPeriod: 27007.23333,
        reactiveEnergyForPeriod: 9005.23333,
        consumptions: [],
        summary: {
          isConsumptionSite: false,
          availablePeriods: [
            {
              periodStartDate: '1982-06-15',
              periodEndDate: '2023-01-28',
              resolution: 'Hourly'
            }
          ],
          estimatedYearlyTotalEnergy: 19800,
          estimatedYearlyNormalEnergy: 7885,
          estimatedYearlyHighEnergy: 6258,
          estimatedYearlyLowEnergy: 5657,
          estimatedYearlyReactiveEnergy: 6454,
          actualEnergy: 3577,
          actualReactiveEnergy: 3589,
          maxPower: {
            value: 227,
            date: '2021-12-09'
          },
          maxReactivePower: {
            value: 211,
            date: '2021-10-09'
          }
        }
      }
    }
    getConsumptionChartDataGenerated.data.consumptions = consumptionsArray

    return getConsumptionChartDataGenerated
  },
  // eslint-disable-next-line
  temperature: function (from, to, resolution) {
    const consumptionData = this.interval(from, to, resolution)

    const smhiData = consumptionData.data.consumptions.map((item) => ({
      timeStamp: item.start + 'T01:00:01',
      temperature: mockDb.randomNumber(0, 20) + Math.random()
    }))

    const returnObject = {
      data: smhiData,
      meta: {
        version: buildVersion,
        count: smhiData.length
      },
      messages: ['Error in temperature'],
      errors: []
    }

    return returnObject
  },
  // eslint-disable-next-line
  effect: function (from, to, resolution) {
    const consumptionData = this.interval(from, to, resolution)

    const effectData = consumptionData.data.consumptions.map((item) => ({
      timestamp: item.start,
      calculatedAvgMaxPower: mockDb.randomNumber(0, 20)
      //index: index
    }))

    const returnObject = {
      data: effectData,
      meta: {
        version: buildVersion,
        count: effectData.length
      },
      messages: [],
      errors: []
    }

    return returnObject
  }
}

export { mockdbchart, generatedObj }

//adjusted for interval - calculated using from and to.
// const generatedObj = {
//   interval: function(from, to, resolution) {
//     const parsedTo = new Date(to)
//     const parsedFrom = new Date(from)

//     const yearDiff = parsedTo.getFullYear() - parsedFrom.getFullYear()
//     const monthDiff = yearDiff * 12 + parsedTo.getMonth() - parsedFrom.getMonth() + 1

//     // if (resolution !== 'Hourly') {
//     //   parsedTo.setUTCHours(0, 0, 0, 0)
//     //   parsedFrom.setUTCHours(0, 0, 0, 0)
//     // }

//     let numOfLoops = 0

//     const millisekOfYear = 1000 * 60 * 60 * 24 * 7 * 4 * 52
//     const millisekOfMonth = 1000 * 60 * 60 * 24 * 7 * 4
//     const millisekOfWeek = 1000 * 60 * 60 * 24 * 7
//     const millisekOfDay = 1000 * 60 * 60 * 24
//     const millisekOfHour = 1000 * 60 * 60

//     const fromDateInMillisek = parsedFrom.getTime()
//     const toDateInMillisek = parsedTo.getTime()

//     const timeDiffInMillisek = toDateInMillisek - fromDateInMillisek

//     const numberOfYears = timeDiffInMillisek / millisekOfYear
//     const numberOfMonths = timeDiffInMillisek / millisekOfMonth
//     const numberOfWeeks = timeDiffInMillisek / millisekOfWeek
//     const numberOfDays = timeDiffInMillisek / millisekOfDay + 1
//     const numberOfHours = timeDiffInMillisek / millisekOfHour

//     if (resolution === 'Yearly') {
//       numOfLoops = Math.round(numberOfYears)
//     } else if (resolution === 'Monthly') {
//       numOfLoops = monthDiff //Math.round(numberOfMonths)
//     } else if (resolution === 'Weekly') {
//       numOfLoops = Math.round(numberOfWeeks)
//     } else if (resolution === 'Daily') {
//       numOfLoops = Math.round(numberOfDays)
//     } else if (resolution === 'Hourly') {
//       numOfLoops = 24 //Math.round(numberOfHours)
//     }

//     const consumptionsArray = []

//     for (let i = 0; i < numOfLoops; i++) {
//       let periodStart = fromDateInMillisek + i * (timeDiffInMillisek / numOfLoops)
//       let periodEnd = fromDateInMillisek + (i + 1) * (timeDiffInMillisek / numOfLoops)

//       if (resolution === 'Hourly') {
//         const periodStartFixed = parsedFrom.toBackendDate() + ` ${i.toString().padStart(2, '0')}:00:00`
//         periodStart = periodStartFixed
//         periodEnd = periodStartFixed
//       } else if (resolution === 'Daily') {
//         const periodStartFixed = new Date(parsedFrom.setDate(i + 1))
//         periodStart = periodStartFixed.toBackendDate() + ' 00:00:00'
//         periodEnd = periodStartFixed.toBackendDate() + ' 23:59:59'
//       } else if (resolution === 'Monthly') {
//         const periodStartFixed = new Date(new Date(parsedFrom.setDate(1)).setMonth(i))
//         periodStart = periodStartFixed.toBackendDate()
//         const periodEndFixed = new Date(new Date(parsedTo).setMonth(i))
//         periodEnd = periodEndFixed.toBackendDate()
//       } else if (resolution === 'Yearly') {
//         const periodStartFixed = new Date(new Date(new Date(periodStart).setDate(1)).setMonth(0))
//         periodStart = periodStartFixed.toBackendDate()
//         const periodEndFixed = new Date(new Date(new Date(periodStart).setDate(31)).setMonth(11))
//         periodEnd = periodEndFixed.toBackendDate()
//       }

//       const normal = parseInt(periodStart, 10) > new Date(new Date().setHours(0, 0, 0, 0)).getTime() ? 0 : Math.floor(Math.random() * 200) + 450

//       consumptionsArray.push({
//         normal: normal,
//         total: normal,
//         start: resolution === 'Hourly' ? periodStart : new Date(periodStart).toBackendDate(),
//         end: resolution === 'Hourly' ? periodEnd : new Date(periodEnd).toBackendDate(),
//         resolution: resolution,
//         canFilter: resolution !== 'Hourly'
//       })
//     }

//     let getConsumptionChartDataGenerated = {
//       data: {
//         showPreviousButton: true,
//         showNextButton: true,
//         responseStartPeriod: new Date(fromDateInMillisek).toBackendDate(), //'2021-02-01',
//         responseEndPeriod: new Date(toDateInMillisek).toBackendDate(), //'2022-02-14',
//         responseResolution: 'Monthly',
//         energyForPeriod: 27007.2,
//         reactiveEnergyForPeriod: 9005.2,
//         consumptions: consumptionsArray,
//         summary: {
//           isConsumptionSite: false,
//           availablePeriods: [
//             {
//               periodStartDate: '1982-06-15',
//               periodEndDate: '2023-01-28',
//               resolution: 'Hourly'
//             }
//           ],
//           estimatedYearlyTotalEnergy: 19800,
//           estimatedYearlyNormalEnergy: 7885,
//           estimatedYearlyHighEnergy: 6258,
//           estimatedYearlyLowEnergy: 5657,
//           estimatedYearlyReactiveEnergy: 6454,
//           actualEnergy: 3577,
//           actualReactiveEnergy: 3589,
//           maxPower: {
//             value: 227,
//             date: '2021-12-09'
//           },
//           maxReactivePower: {
//             value: 211,
//             date: '2021-10-09'
//           }
//         }
//       }
//     }

//     return getConsumptionChartDataGenerated
//   },
//   // eslint-disable-next-line
//   temperature: function(from, to, resolution) {
//     const consumptionData = this.interval(from, to, resolution)

//     const smhiData = consumptionData.data.consumptions.map(item => ({
//       timeStamp: item.start,
//       temperature: mockDb.randomNumber(0, 20)
//     }))

//     const returnObject = {
//       data: smhiData,
//       meta: {
//         count: smhiData.length
//       },
//       messages: [],
//       errors: []
//     }

//     return returnObject
//   }
// }

// export { mockdbchart, generatedObj }
